module.exports = {
  "version": "0.27.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 249
// module chunks = 9